import type { Components } from "@mui/material/styles";

export const MuiAlert: Components["MuiAlert"] = {
  styleOverrides: {
    root: {
      "&.MuiAlert-colorInfo": {
        borderColor: "var(--color-blue)",
        backgroundColor: "var(--color-blue-light)",
      },
      "&.MuiAlert-colorError": {
        borderColor: "var(--color-red)",
        backgroundColor: "var(--color-red-light)",
      },
      "&.MuiAlert-colorSuccess": {
        borderColor: "var(--color-emerald)",
        background: "var(--color-emerald-light)",
      },
    },
    message: {
      color: "var(--color-black)",
    },
  },
};
